export default __webpack_public_path__ + "760f1ffe6c62094a158e7ae44489cda7.png";